export const icons = [
  {
    icon: "mdi-instagram",
    link: "https://www.instagram.com/jackson_santin"
  },
  {
    icon: "mdi-linkedin",
    link: "https://www.linkedin.com/in/jackson-dhanyel-santin"
  },
  {
    icon: "mdi-github",
    link: "https://github.com/JacksonSantin"
  },
  {
    icon: "mdi-whatsapp",
    link: "https://api.whatsapp.com/send?phone=54996262629"
  },
  {
    icon: "mdi-web",
    link: "https://about-me-jacksonsantin.vercel.app/"
  },
]